import * as actionTypes from "../actions/actionTypes";
import uuidv1 from "uuid/v1";

const initialState = {
	isLoading: true,
	errorMessage: "",
	timezones: null,
	displayPreview: false,
	quickMessages: [],
};

export default function controlPanelReducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.CONTROL_PANEL_INIT_COMPLETE:
			return Object.assign({}, state, {
				isLoading: false,
			});
		case actionTypes.DISPLAY_ERROR:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case actionTypes.DISPLAY_QUICK_MESSAGE:
			var obj = {
				id: uuidv1(),
				message: action.message,
				status: action.status,
				icon: action.icon,
			};
			var newVal = Object.assign({}, state);
			newVal.quickMessages.push(obj);
			return newVal;
		case actionTypes.REMOVE_QUICK_MESSAGE:
			return Object.assign({}, state, {
				quickMessages: state.quickMessages.filter(function(obj) {
					return obj.id !== action.id;
				}),
			});
		case actionTypes.LOAD_TIMEZONES_SUCCESS:
			return Object.assign({}, state, {
				timezones: action.data,
			});
		case actionTypes.HIDE_LOADING:
			return Object.assign({}, state, {
				isLoading: false,
			});
		case actionTypes.SHOW_LOADING:
			return Object.assign({}, state, {
				isLoading: true,
			});
		case actionTypes.TOGGLE_APP_PREVIEW:
			return Object.assign({}, state, {
				displayPreview: !state.displayPreview,
			});
		default:
			return state;
	}
}
